import { Navigate } from "react-router-dom";
import {
  LocalStorage,
  getCredential
} from "../utils/api/endpoints/user/credentials";

/**
 * Default page for site root
 * (No content - just decides where the user should go next)
 */
const LandingPage = () => {
  const accessToken = getCredential(LocalStorage.ACCESS_TOKEN);

  // Forward the user onto the
  if ((accessToken || undefined) !== undefined) {
    return <Navigate to="/dashboard" />;
  } else {
    return <Navigate to="/login" />;
  }
};

export default LandingPage;
